import { useContext } from "react";
import { SharedAlarmReceptionContext } from "./SharedAlarmReceptionContext";

const useSharedAlarmReception = () => useContext(SharedAlarmReceptionContext);

export default useSharedAlarmReception;
